(function () {
  'use strict';

  var MONEY_SELECTOR = '.tp-pdp [data-price], .tp-pdp [data-compare], .tp-pdp .tp-tabby-payment__amount, .tp-pdp .tp-pdp__trust-item span';
  var MONEY_PATTERN = /(?:\u20C1\s*([0-9٠-٩][0-9٠-٩,.٬٫]*)|([0-9٠-٩][0-9٠-٩,.٬٫]*)\s*\u20C1)/g;
  var STYLE_ID = 'tp-riyal-pdp-fix-styles';

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.tp-pdp .tp-riyal-money{display:inline-flex;align-items:center;gap:.30em;direction:ltr;unicode-bidi:isolate;white-space:nowrap;vertical-align:baseline}',
      '.tp-pdp .tp-riyal-symbol{display:inline-block;width:.82em;height:.82em;flex:0 0 .82em;background-color:currentColor;-webkit-mask-image:var(--tp-riyal-symbol);mask-image:var(--tp-riyal-symbol);-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;-webkit-mask-position:center;mask-position:center;-webkit-mask-size:contain;mask-size:contain}',
      '@supports not ((mask-image:url("")) or (-webkit-mask-image:url(""))){.tp-pdp .tp-riyal-symbol{background-color:transparent;background-image:var(--tp-riyal-symbol);background-position:center;background-repeat:no-repeat;background-size:contain}}'
    ].join('');
    document.head.appendChild(style);
  }

  function appendMoney(fragment, amount) {
    var money = document.createElement('span');
    money.className = 'tp-riyal-money';
    money.setAttribute('dir', 'ltr');

    var symbol = document.createElement('span');
    symbol.className = 'tp-riyal-symbol';
    symbol.setAttribute('aria-hidden', 'true');

    var value = document.createElement('span');
    value.className = 'tp-riyal-value';
    value.textContent = amount;

    var spoken = document.createElement('span');
    spoken.className = 'visually-hidden';
    spoken.textContent = ' ريال سعودي';

    money.appendChild(symbol);
    money.appendChild(value);
    fragment.appendChild(money);
    fragment.appendChild(spoken);
  }

  function enhanceElement(element) {
    if (!element || element.children.length && !element.textContent.includes('\u20C1')) return;

    var raw = element.textContent || '';
    if (raw.indexOf('\u20C1') === -1) return;

    MONEY_PATTERN.lastIndex = 0;
    var matches = Array.from(raw.matchAll(MONEY_PATTERN));
    if (!matches.length) return;

    var fragment = document.createDocumentFragment();
    var cursor = 0;

    matches.forEach(function (match) {
      if (match.index > cursor) {
        fragment.appendChild(document.createTextNode(raw.slice(cursor, match.index)));
      }

      appendMoney(fragment, match[1] || match[2] || '');
      cursor = match.index + match[0].length;
    });

    if (cursor < raw.length) {
      fragment.appendChild(document.createTextNode(raw.slice(cursor)));
    }

    element.replaceChildren(fragment);
  }

  function process(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches(MONEY_SELECTOR)) {
      enhanceElement(scope);
    }

    scope.querySelectorAll(MONEY_SELECTOR).forEach(enhanceElement);
  }

  function init() {
    addStyles();
    process(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') {
          var parent = mutation.target && mutation.target.parentElement;
          if (parent && parent.closest('.tp-pdp')) process(parent.closest('.tp-pdp'));
          return;
        }

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) process(node);
          else if (node.parentElement && node.parentElement.closest('.tp-pdp')) process(node.parentElement.closest('.tp-pdp'));
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    addStyles();
    process(event.target);
  });
})();
